export const SET_FILTER_COLORS_ARRAY = "SET_FILTER_COLORS_ARRAY";
export const SET_FILTER_BRANDS_ARRAY = "SET_FILTER_BRANDS_ARRAY";
export const SET_FILTER_TYPES_ARRAY = "SET_FILTER_TYPES_ARRAY";
export const SET_FILTER_CATEGORIES_ARRAY = "SET_FILTER_CATEGORIES_ARRAY";
export const SET_FILTER_SUBCATEGORIES_ARRAY = "SET_FILTER_SUBCATEGORIES_ARRAY";
export const SET_FILTER_PRICES_ARRAY = "SET_FILTER_PRICES_ARRAY";
export const SET_SORT_FILTER = "SET_SORT_FILTER";